module.exports = __webpack_public_path__ + "static/img/android-chrome-512x512.5b98b6b6.png";